import { Grid } from '@chakra-ui/react';
import {
  useCalibrationScoreSettings,
  useGridDefinitionMetaData,
  useReviewCreationData,
} from 'reducers/reviewCreationSlice';

import { Calibrate } from 'assets/assetsV1/iconComponents';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';

import { useGetCalibrationSettings } from '../../Hooks/dataHooks/calibrationDataHooks';
import { AnswerTypes, AnswerTypesLabel } from '../Calibration/ScoreSection';
import { Detail, RenderDetails } from './RenderDetails';

const ScoreSettings = () => {
  const { answerType, answerOptions } = useCalibrationScoreSettings();
  if (!answerType || !answerOptions) {
    return null;
  }
  const totalOptions = `${answerOptions.length} ${answerOptions.length > 1 ? 'Options' : 'Option'}`;
  const answerDescriptions = answerOptions
    .map((o, i) => {
      const prev = answerOptions[i - 1] || { score: 0 };
      const { description } = o;
      return `${prev.score}-${o.score}${description ? `: ${description}` : ''}`;
    })
    .join(', ');

  const scoreComputation = {
    [AnswerTypes.DROP_DOWN]: `${totalOptions} (${answerDescriptions})`,
    [AnswerTypes.NUMBER_RATING]: `Max score: ${answerOptions[answerOptions.length - 1].score}`,
  };

  const details: Detail[] = [
    {
      key: 'Score Settings',
      value: '',
      isHeader: true,
    },
    {
      key: 'Score Type',
      value: AnswerTypesLabel[answerType],
    },
    {
      key: 'Score Computation:',
      value: scoreComputation[answerType],
    },
  ];

  return <RenderDetails details={details} />;
};

const PerformanceGrid = () => {
  const { rowsCount, columnsCount } = useGridDefinitionMetaData();

  const details: Detail[] = [
    {
      key: 'Performance Grid',
      value: '',
      isHeader: true,
    },
    {
      key: 'Performance Grid Type:',
      value: `${rowsCount}x${columnsCount} Grid`,
    },
  ];

  return <RenderDetails details={details} />;
};

export const Calibration = () => {
  const { reviewCycleId } = useReviewCreationData();

  const { isSuccess, isLoading } = useGetCalibrationSettings({ reviewCycleId });

  if (!isSuccess) return null;

  return (
    <ExpandablePaper showLoader={isLoading}>
      <ExpandablePaperHeader title="Calibration" leftIconComponent={<Calibrate boxSize="24px" color="icon.g2" />} />
      <ExpandablePaperBody>
        <Grid templateColumns="1fr 2fr" rowGap={8} columnGap={8} p="16px 8px 12px" bgColor="white">
          <ScoreSettings />
          <PerformanceGrid />
        </Grid>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
